import { advertNewsCardsContainerElement } from "@modules/global/dom.ts"
import {
    injectTrafficStarsScript,
    trafficStarsBeforePaginationHtmlMobile,
    trafficStarsBeforePaginationHtmlPc,
    trafficStarsMobilePaginationSpot,
    trafficStarsMobilePaginationTemplateId,
    trafficStarsPcPaginationSpot,
    trafficStarsPcPaginationTemplateId,
    trafficStarsTemplateDataId,
} from "@modules/traffic-stars/templates"
import { trafficStarsOnWindowResizeDebounceMs } from "@modules/traffic-stars/traffic-stars.ts"
import { isMobile, isPC } from "@modules/util/device"
import { debounce } from "lodash-es"

export function rerenderTrafficStarsBeforePagination() {
    if (userData.hasAdFree || !userData.isAgeVerified) {
        return
    }

    // remove existing element
    const trafficStarsElement = document.querySelector(`[data-traffic-stars-id="${trafficStarsTemplateDataId}"]`)
    if (trafficStarsElement) {
        trafficStarsElement.remove()
    }

    const html = isPC() ? trafficStarsBeforePaginationHtmlPc() : trafficStarsBeforePaginationHtmlMobile
    advertNewsCardsContainerElement()?.insertAdjacentHTML("afterend", html)

    // Script must be created programmatically so the browser executes it fresh
    // even when ms.js is already loaded by another ad on the page.
    const container = document.querySelector(
        `[data-traffic-stars-id="${trafficStarsTemplateDataId}"] .uncensored-banner-container`,
    )
    if (container) {
        const [spot, templateId] = isPC()
            ? [trafficStarsPcPaginationSpot, trafficStarsPcPaginationTemplateId]
            : [trafficStarsMobilePaginationSpot, trafficStarsMobilePaginationTemplateId]
        injectTrafficStarsScript(container, spot, templateId)
    }
}

if (!userData.hasAdFree && userData.isAgeVerified) {
    window.addEventListener(
        "orientationchange",
        debounce(() => {
            rerenderTrafficStarsBeforePagination()
        }, trafficStarsOnWindowResizeDebounceMs),
    )

    // DONT initiate an event listener on resize to rerender solads or traffic stars on mobile
    // It will trigger on mobile when scrolling and the browser bar shows/hides. Which triggers a lot of rerenders while scrolling
    // alternative fix would be to check for width changes only.
    if (!isMobile()) {
        window.addEventListener(
            "resize",
            debounce(() => {
                rerenderTrafficStarsBeforePagination()
            }, trafficStarsOnWindowResizeDebounceMs),
        )
    }
    rerenderTrafficStarsBeforePagination()
}
